import { Link } from 'react-router-dom';

// T119 — shared button primitive. Encapsulates the exact themed class strings
// already used across the app (bg-brand-600 primary / border-slate-700
// secondary / etc.) so the look is identical and every theme keeps working via
// the index.css utility overrides. No visual change — this just centralises the
// strings that were copied 40+ times.
//
// Polymorphic: pass `to` → renders a react-router <Link>; otherwise a
// <button type="button"> (default type avoids accidental form submits — most
// call sites set it explicitly today). Pass `type="submit"` via `...rest` for
// real submit buttons.
const VARIANTS = {
  primary: 'bg-brand-600 text-white hover:bg-brand-500',
  secondary: 'border border-slate-700 text-slate-300 hover:border-brand-600 hover:text-brand-400',
  ghost: 'text-slate-400 hover:text-slate-200',
  danger: 'border border-slate-700 text-slate-300 hover:border-red-600 hover:text-red-400',
};
const SIZES = { sm: 'px-3 py-1.5 text-xs', md: 'px-4 py-2 text-sm' };

export default function Button({
  variant = 'secondary',
  size = 'md',
  to,
  className = '',
  ...rest
}) {
  const cls =
    `rounded-md font-medium transition disabled:opacity-50 ${VARIANTS[variant] ?? VARIANTS.secondary} ${SIZES[size] ?? SIZES.md} ${className}`.trim();
  if (to) return <Link to={to} className={cls} {...rest} />;
  return <button type="button" className={cls} {...rest} />;
}
